import { alpha, Box, styled, lighten, darken } from '@mui/material';


export const Field = styled(Box)(({ oldValue, newValue, noBox, theme }: any) => ({
    minWidth: 200,
    minHeight: 40,
    width: noBox ? '100%' : undefined,
    marginLeft: 'auto',
    border: noBox ?
        `solid 1px transparent` :
        theme.palette.mode === 'dark' ? 
            `solid 1px ${alpha(theme.palette.common.white, 0.12)}` :
            `solid 1px ${alpha(theme.palette.common.black, 0.12)}`,
    padding: noBox ? theme.spacing(1, 0, 1, 0) : theme.spacing(1, 1, 1, 1),
    background: noBox ?
        'transparent' :
        oldValue ?
            theme.palette.mode === 'dark' ? 
                lighten(theme.palette.error.main, 0.15) :
                lighten(theme.palette.error.light, 0.15) :
            newValue ?
                theme.palette.mode === 'dark' ? 
                    lighten(theme.palette.success.main, 0.15) :
                    lighten(theme.palette.success.light, 0.15) :
                theme.palette.mode === 'dark' ? 
                    lighten(theme.palette.common.black, 0.15) :
                    darken(theme.palette.common.white, 0.01),

    flex: oldValue || newValue ? '1 1 auto' : undefined, 
    alignSelf: oldValue || newValue ? 'stretch' : undefined, 
    borderRadius: oldValue || newValue ? 0 : theme.shape.borderRadius
}));

export const Format = styled('pre')(({ theme }) => ({
    ...theme.typography.body1,
    margin: 0,
    whiteSpace: 'pre-wrap'
}));